import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { type SvgIconOwnProps } from '@mui/material/SvgIcon';

type CloseButtonProps = {
  onClick: (...args: any[]) => any;
  iconSx?: SvgIconOwnProps['sx'];
};

function CloseButton({ onClick, iconSx }: CloseButtonProps) {
  return (
    <IconButton onClick={onClick} aria-label="Close" data-testid="close-button">
      <CloseIcon sx={iconSx} />
    </IconButton>
  );
}

export default CloseButton;
